import { chartColors } from "../../../reports/colors";

// Extracted from the identical processChartData() copy-pasted in
// GemstoneReportsColorComp/SizeComp/PriceComp/ClarityComp.
export const DEFAULT_MAX_ENTRIES = 15;

export const bucketTopN = (
  list,
  { labelKey, valueKey, chartLabel, max = DEFAULT_MAX_ENTRIES, othersLabel }
) => {
  if (!list?.length) {
    return { chartData: [], colors: [], othersCount: 0 };
  }

  // valueKey can come back as a string from the API -- `+` on two strings
  // concatenates instead of adding, so every numeric read here goes through
  // Number(...) to force arithmetic (was producing a garbage concatenated
  // "Others" value, plus wrong totals/percentages, once enough rows piled up).
  const filteredData = list.filter((item) => Number(item[valueKey]) > 0);
  const sortedData = [...filteredData].sort(
    (a, b) => Number(b[valueKey]) - Number(a[valueKey])
  );

  const topData = sortedData.slice(0, max);
  const remainingData = sortedData.slice(max);

  const othersValue = remainingData.reduce(
    (sum, item) => sum + Number(item[valueKey] || 0),
    0
  );
  if (othersValue > 0 && remainingData.length > 0) {
    topData.push({
      [labelKey]: othersLabel,
      [valueKey]: othersValue,
      isOthers: true,
    });
  }

  const total = topData.reduce((sum, item) => sum + Number(item[valueKey] || 0), 0);

  const processedChartData = [[chartLabel, "Count"]];
  const colors = [];

  topData.forEach((item, index) => {
    const value = Number(item[valueKey] || 0);
    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
    const color = item.isOthers
      ? "#CCCCCC"
      : chartColors[index % chartColors.length];
    colors.push(color);
    processedChartData.push([
      `${item[labelKey]} (${percentage}%)`,
      value,
    ]);
  });

  return { chartData: processedChartData, colors, othersCount: remainingData.length };
};

// bucketTopN() bakes "(NN.N%)" into every chart label — this strips it back
// off so a clicked slice's label can be sent to the backend/table filter as
// the raw attribute value (e.g. "Red (12.3%)" -> "Red").
export const stripPctLabel = (label) => String(label).replace(/\s*\([^)]*\)\s*$/, "");
